import { useRouter } from 'next/router';

export function useListingQueryItem() {
  const router = useRouter();
  
  return router.query.listing !== undefined ? Number(String(router.query.listing)) : undefined;
}
